<template>
  <div :class="['navbar-box flex-c-b', showHeader ? 'has-header' : 'no-header', mode]">
    <div class="left-nav flex-c-s">
      <hamburger></hamburger>
      <breadcrumb></breadcrumb>
    </div>
    <div class="right-nav" v-if="!showHeader">
      <right-nav></right-nav>
    </div>
  </div>
</template>

<script>
import Hamburger from "./hamburger"
import Breadcrumb from "./breadcrumb"
import RightNav from "./right-nav"
export default {
  components: {
    Hamburger,
    Breadcrumb,
    RightNav
  },
  computed: {
    //展示头部
    showHeader() {
      return this.$store.state.setting.showHeader
    },
    mode() {
      return this.$store.state.setting.mode
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar-box{
  width: 100%;
  background: #008CFF;
  height: $LayoutHeaderHeight;
}
</style>